import Vue from 'vue';
import { auth } from '../fb';
import { onAuthStateChanged } from "firebase/auth";
import axios from 'axios';
import store from '../store.js';
var config = require("@/config/api.json");
const API = config.api;

Vue.mixin({
    data() {
        return {
            notificationActive: false,
            loadingStuff: null,
            user: null,
            storedUser: null
        };
    },
    mounted() {
        try {
            this.storedUser = localStorage.getItem("user");
            if (this.storedUser) {
                this.storedUser = JSON.parse(this.storedUser);
            }
        } catch (e) {
            console.error("Error parsing stored user data:", e);
        }
    },
    methods: {

        async callAudit(personal_medico_id,accion,tabla_afectada,id_registro_afectado,detalles) {

            await axios.post(`${API}/callAuditoria`, {
                personal_medico_id: personal_medico_id,
                accion: accion,
                tabla_afectada: tabla_afectada,
                id_registro_afectado: id_registro_afectado,
                detalles: detalles
              })
              .then(() => {
                console.log("Evento de auditoría registrado exitosamente.");
              })
              .then(() => {
                console.log("Evento de auditoría registrado exitosamente.");
              })
              .catch((error) => {
                console.error("Error al registrar el evento de auditoría:", error);
              });

        },


        scrollToBottom() {
            window.scrollTo({
                top: document.documentElement.scrollHeight,
                behavior: 'smooth'
            });
        },
        hasPermission(dbName, permissions) {
            if (permissions) {
                return permissions.some(
                    (permission) => permission.dbName === dbName
                );
            }
            return false;
        },
        getUser() {
            return this.user;
        },
        getUserStatus(){
            return localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).expirado : 0;
        },
        async checkAuthState() {
            try {
                const user = await new Promise((resolve, reject) => {
                    onAuthStateChanged(auth, (user) => {
                        if (user) {
                            resolve(user);
                        } else {
                            reject('No user');
                        }
                    });
                });

                await this.handleAuthenticatedUser(user);
            } catch (error) {
                // console.log('EROR AUTH:::::::::::::::::', error)
                this.handleUnauthenticatedUser();
            }
        },
        async handleAuthenticatedUser(user) {
            const targetRoute = '/home';
            this.user = user;
            // console.log('USUARIO', user)
            await this.$store.dispatch('updateDisplayName', this.user.displayName);

            let userBackend;

            // Verificar si los datos del usuario están almacenados en localStorage
            const storedUser = localStorage.getItem('user');
            if (storedUser) {
                // Recuperar los datos del usuario y sus permisos del localStorage
                userBackend = JSON.parse(storedUser);
            } else {
                // Obtener los permisos del usuario desde el servidor
                try {
                    const response = await axios.get(`${API}/getUserInfo/${this.user.uid}`);
                    userBackend = response.data;
                    // console.log(`${API}/getUserInfo/${this.user.uid}`)
                    // console.log('Usuario guardado BACKEND...', userBackend.id)
                    this.user = { ...this.user, mainId: userBackend.id };
                    // console.log('Usuario guardado...', this.user);
                    localStorage.setItem('user', JSON.stringify(this.user));
                    // Actualizar el estado con los datos del usuario y sus permisos
                    if (user) {
                        // console.log('ENTRA PERMISOS', this.user)
                        await this.$store.dispatch('updateUser', this.user);
                    }
                } catch (error) {
                    console.error('Error al obtener el usuario y sus permisos:', error);
                }
            }



            // Redireccionar a la ruta de destino
            if (this.$route.path !== targetRoute) {
                await new Promise(resolve => setTimeout(resolve, 1000));
                this.$router.push({ name: 'Home' });
            }
        },
        async updateUserInfo(uid) {
            // Obtener los permisos del usuario desde el servidor
            await axios.get(`${API}/manager-user/${uid}`)
                .then(response => {
                    const userWithPermissions = response.data;
                    // Actualizar el estado con el usuario y sus permisos
                    this.$store.dispatch('updateUser', userWithPermissions);

                    // Almacenar los datos del usuario y sus permisos en localStorage
                    localStorage.setItem('user', JSON.stringify(userWithPermissions));
                })
                .catch(error => {
                    console.error('Error al obtener el usuario y sus permisos:', error);
                });
        },
        handleUnauthenticatedUser() {
            this.user = null;

            const targetRoute = '/';
            if (this.$route.path !== targetRoute) {
                this.$router.push(targetRoute);
            }
        },
        logout() {
            localStorage.removeItem('user')
            auth.signOut()
                .catch((error) => {
                    this.notify('error', `Error al cerrar sesión: ${error.message}`);
                });
            const targetRoute = '/';
            if (this.$route.path !== targetRoute) {
                this.$router.push(targetRoute);
            }
        },
        notify(type, text) {
            if (this.notificationActive) {
                return;
            }

            let notificationConfig = {
                color: 'dark',
                title: '',
                text: text,
            };

            switch (type) {
                case 'success':
                    notificationConfig.title = '✅ Éxito';
                    break;
                case 'error':
                    notificationConfig.title = '❌ Error';
                    break;
                case 'info':
                    notificationConfig.title = 'ℹ️ Mensaje';
                    break;
            }

            this.$vs.notification(notificationConfig);

            this.notificationActive = true;

            setTimeout(() => {
                this.notificationActive = false;
            }, 3000);
        },
        openLoading() {
            this.loadingStuff = this.$vs.loading({
                background: '#214455',
                color: '#fff'
            })
        },
        closeLoading() {
            this.loadingStuff.close()
        },
        vEmpty(value, fieldName) {
            if (value == null || value.trim() === '') {
                this.notify('error', `Error: ${fieldName} esta vacio`);
                return false;
            }
            return true;
        },

        vNumber(value, fieldName) {
            if (isNaN(value)) {
                this.notify('error', `Error: ${fieldName} no es un número valido`);
                return false;
            }
            return true;
        },

        vEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },

        vUrl(url, fieldName) {
            try {
                new URL(url);
                return true;
            } catch (_) {
                this.notify('error', `Error: ${fieldName} no es una dirección URL válida`);
                return false;
            }
        },
        formatDate(dateString) {
            try {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
            } catch (error) {
            this.notify('error', 'Error: Invalid date format');
            return null;
            }
        },
        vPhoneMask(value, fieldName) {
            const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
            if (value && !phoneRegex.test(value)) {
                this.notify('error', `Error: ${fieldName} debe tener el formato ###-###-#### o estar vacío.`);
                return false;
            }
            return true;
        },
        isMobileDevice() {
            // Validación más avanzada para detectar dispositivos móviles
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Detectar dispositivos iOS o Android
            if (/android/i.test(userAgent)) {
            return true;
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return true;
            }

            // Detectar otros dispositivos móviles
            return /Mobile|webOS|BlackBerry|IEMobile|Opera Mini|Silk/i.test(userAgent);
        },
    }
});